/**
 * Cookie Preferences Handler
 * Uses official Shopify Customer Privacy API
 */

(function() {
  function openCookiePreferences() {
    // Official Shopify method
    if (window.Shopify && window.Shopify.customerPrivacy) {
      // Method 1: Try the official showPreferences method
      if (typeof window.Shopify.customerPrivacy.showPreferences === 'function') {
        window.Shopify.customerPrivacy.showPreferences();
        return;
      }
    }
    
    // If Shopify API is not loaded yet, load it first
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([
        {
          name: 'consent-tracking-api',
          version: '0.1',
        }
      ], function(error) {
        if (error) {
          createFallbackDialog();
          return;
        }
        
        if (window.Shopify.customerPrivacy) {
          // Try again after loading
          if (typeof window.Shopify.customerPrivacy.showPreferences === 'function') {
            window.Shopify.customerPrivacy.showPreferences();
          } else {
            // Try to find and show existing privacy banner
            findAndShowPrivacyBanner();
          }
        } else {
          createFallbackDialog();
        }
      });
    } else {
      createFallbackDialog();
    }
  }
  
  function findAndShowPrivacyBanner() {
    // Look for existing Shopify privacy banner elements
    const bannerSelectors = [
      '[data-shopify-privacy-banner]',
      '.shopify-privacy-banner',
      '#shopify-privacy-banner',
      '[data-privacy-banner]',
      '.cookie-banner'
    ];
    
    let banner = null;
    for (const selector of bannerSelectors) {
      banner = document.querySelector(selector);
      if (banner) {
        break;
      }
    }
    
    if (banner) {
      // Show the banner
      banner.style.display = 'block';
      banner.style.visibility = 'visible';
      banner.style.opacity = '1';
      banner.style.position = 'fixed';
      banner.style.zIndex = '10000';
      
      // Try to find and click "Manage preferences" button
      const manageButtons = banner.querySelectorAll('button, a');
      for (const btn of manageButtons) {
        const text = btn.textContent.toLowerCase();
        if (text.includes('manage') || text.includes('preferences') || text.includes('customize')) {
          setTimeout(() => btn.click(), 100);
          return;
        }
      }
    } else {
      createFallbackDialog();
    }
  }
  
  function createFallbackDialog() {
    // Only create if not already exists
    if (document.getElementById('cookie-preferences-dialog')) {
      return;
    }
    
    // Get current consent status if available
    let currentConsent = {};
    if (window.Shopify?.customerPrivacy) {
      currentConsent = {
        marketing: window.Shopify.customerPrivacy.marketingAllowed(),
        analytics: window.Shopify.customerPrivacy.analyticsProcessingAllowed(),
        preferences: window.Shopify.customerPrivacy.preferencesProcessingAllowed()
      };
    }
    
    // Create dialog HTML
    const dialogHTML = `
      <div id="cookie-preferences-dialog" style="
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 10000;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      ">
        <div style="
          background: white;
          border-radius: 8px;
          padding: 32px;
          max-width: 600px;
          width: 90%;
          max-height: 80vh;
          overflow-y: auto;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
        ">
          <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 24px;">
            <h2 style="margin: 0; font-size: 24px; font-weight: 600; color: #333;">Cookie preferences</h2>
            <button onclick="closeCookieDialog()" style="
              background: none;
              border: none;
              font-size: 24px;
              cursor: pointer;
              padding: 0;
              color: #666;
              width: 32px;
              height: 32px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
            ">×</button>
          </div>
          
          <div style="margin-bottom: 32px;">
            <h3 style="margin: 0 0 8px 0; font-size: 18px; font-weight: 600; color: #333;">You control your data</h3>
            <p style="margin: 0; color: #666; line-height: 1.5;">Learn more about the cookies we use, and choose which cookies to allow.</p>
          </div>
          
          <div style="margin-bottom: 24px;">
            <div style="display: flex; align-items: center; margin-bottom: 12px;">
              <input type="checkbox" checked disabled style="margin-right: 12px; width: 16px; height: 16px;">
              <h4 style="margin: 0; font-size: 16px; font-weight: 600; color: #333;">Required</h4>
            </div>
            <p style="margin: 0 0 24px 28px; color: #666; font-size: 14px; line-height: 1.4;">
              These cookies are necessary for the site to function properly, including capabilities like logging in and adding items to the cart.
            </p>
          </div>
          
          <div style="margin-bottom: 24px;">
            <div style="display: flex; align-items: center; margin-bottom: 12px;">
              <input type="checkbox" id="preferences-checkbox" ${currentConsent.preferences ? 'checked' : ''} style="margin-right: 12px; width: 16px; height: 16px;">
              <h4 style="margin: 0; font-size: 16px; font-weight: 600; color: #333;">Personalization</h4>
            </div>
            <p style="margin: 0 0 24px 28px; color: #666; font-size: 14px; line-height: 1.4;">
              These cookies store details about your actions to personalize your next visit to the website.
            </p>
          </div>
          
          <div style="margin-bottom: 24px;">
            <div style="display: flex; align-items: center; margin-bottom: 12px;">
              <input type="checkbox" id="marketing-checkbox" ${currentConsent.marketing ? 'checked' : ''} style="margin-right: 12px; width: 16px; height: 16px;">
              <h4 style="margin: 0; font-size: 16px; font-weight: 600; color: #333;">Marketing</h4>
            </div>
            <p style="margin: 0 0 24px 28px; color: #666; font-size: 14px; line-height: 1.4;">
              These cookies are used to optimize marketing communications and show you ads on other sites.
            </p>
          </div>
          
          <div style="margin-bottom: 32px;">
            <div style="display: flex; align-items: center; margin-bottom: 12px;">
              <input type="checkbox" id="analytics-checkbox" ${currentConsent.analytics ? 'checked' : ''} style="margin-right: 12px; width: 16px; height: 16px;">
              <h4 style="margin: 0; font-size: 16px; font-weight: 600; color: #333;">Analytics</h4>
            </div>
            <p style="margin: 0 0 24px 28px; color: #666; font-size: 14px; line-height: 1.4;">
              These cookies help us understand how you interact with the site. We use this data to identify areas to improve.
            </p>
          </div>
          
          <div style="display: flex; gap: 12px; flex-wrap: wrap;">
            <button onclick="acceptAllCookies()" style="
              background: #333;
              color: white;
              border: none;
              padding: 12px 24px;
              border-radius: 4px;
              cursor: pointer;
              font-size: 14px;
              font-weight: 500;
            ">Accept all</button>
            <button onclick="declineAllCookies()" style="
              background: white;
              color: #333;
              border: 1px solid #ddd;
              padding: 12px 24px;
              border-radius: 4px;
              cursor: pointer;
              font-size: 14px;
              font-weight: 500;
            ">Decline all</button>
            <button onclick="saveChoices()" style="
              background: white;
              color: #333;
              border: 1px solid #ddd;
              padding: 12px 24px;
              border-radius: 4px;
              cursor: pointer;
              font-size: 14px;
              font-weight: 500;
            ">Save my choices</button>
          </div>
        </div>
      </div>
    `;
    
    // Add dialog to page
    document.body.insertAdjacentHTML('beforeend', dialogHTML);
    
    // Add event handlers
    window.closeCookieDialog = function() {
      const dialog = document.getElementById('cookie-preferences-dialog');
      if (dialog) dialog.remove();
    };
    
    window.acceptAllCookies = function() {
      if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
        window.Shopify.customerPrivacy.setTrackingConsent({
          marketing: true,
          analytics: true,
          preferences: true,
          sale_of_data: true
        });
      }
      closeCookieDialog();
    };
    
    window.declineAllCookies = function() {
      if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
        window.Shopify.customerPrivacy.setTrackingConsent({
          marketing: false,
          analytics: false,
          preferences: false,
          sale_of_data: false
        });
      }
      closeCookieDialog();
    };
    
    window.saveChoices = function() {
      const preferences = document.getElementById('preferences-checkbox').checked;
      const marketing = document.getElementById('marketing-checkbox').checked;
      const analytics = document.getElementById('analytics-checkbox').checked;
      
      if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
        window.Shopify.customerPrivacy.setTrackingConsent({
          marketing: marketing,
          analytics: analytics,
          preferences: preferences,
          sale_of_data: marketing
        });
      }
      closeCookieDialog();
    };
  }
  
  function initCookiePreferences() {
    const selectors = [
      '[data-cookie-preferences]',
      'a[href="#cookie-preferences"]',
      'a[href*="cookie-preferences"]'
    ];
    
    const cookiePreferenceLinks = document.querySelectorAll(selectors.join(', '));
    
    if (cookiePreferenceLinks.length > 0) {
      cookiePreferenceLinks.forEach((link) => {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          openCookiePreferences();
        });
      });
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookiePreferences);
  } else {
    initCookiePreferences();
  }
  
  // Also expose function globally for manual testing
  window.openCookiePreferences = openCookiePreferences;
})();
